import { useEffect } from "react";
import { PageHeader } from "../components/lendx/PageHeader";
import { Reveal } from "../components/lendx/Reveal";
import { ServiceCard } from "../components/lendx/ServiceCard";
import { PremiumServices } from "../components/lendx/PremiumServices";
import { CTABanner } from "../components/lendx/CTABanner";
import { SERVICES } from "../lib/data";
import { applySEO } from "../lib/scroll";

export default function SolutionsPage() {
  useEffect(() => {
    applySEO(
      "Loan Solutions | LendX — Home Loan, LAP, Business Loan, Corporate Finance",
      "Explore LendX loan solutions: Home Loan, Loan Against Property, Business Loan, Working Capital Finance, Commercial Property Finance, Construction Finance, Lease Rental Discounting and Corporate Finance."
    );
  }, []);

  return (
    <main data-testid="solutions-page">
      <PageHeader
        overline="Our Loan Solutions"
        title="Eight Solution Areas. One Advisory Partner."
        sub="From residential purchases to corporate capital structures — explore financing solutions designed around your requirement."
        testId="solutions"
      />
      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto grid max-w-7xl gap-4 px-5 md:grid-cols-2 md:px-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08} y={30} className="h-full">
              <ServiceCard service={s} />
            </Reveal>
          ))}
        </div>
      </section>
      <PremiumServices />
      <CTABanner />
    </main>
  );
}
